import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'calsoftDate'
})

export class CalsoftDatePipe implements PipeTransform {
  constructor(public datepipe: DatePipe) {

  }
  transform(value: any): string {

    const splittedText = this.datepipe.transform(value, 'dd-MM-yyyy');

    return splittedText;
  }
}
